import React, { useState } from 'react'

import Avatar from 'react-avatar-edit'

import LABEL from '../../business-const/Label/Label'

import { 
    IsXsDownScreen
} from '../../business-components/Service/GlobalService'



const AvatarEdit = (props) => {

    const [src, setSrc] = useState(null)

    const onCrop = view => {
        setSrc(view)
    }

    const onClose = () => {
        props.setFieldValue(props.name, src)
    }

    const isXsDownScreen = IsXsDownScreen()



    return (
        <Avatar
            width={isXsDownScreen ? 365 : 400}
            height={300}
            label={props.label ? props.label : LABEL.selecionarImagem}
            onCrop={onCrop}
            onClose={onClose}
            //src={src}
        />
    )
}

export default AvatarEdit